import * as angular from 'angular';
import * as _ from 'lodash';
import {ConfigScope, EquipmentDataPoint} from "./config.base";
import {DefectType} from "../../models/defectType";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './heyeDataPoints.tpl.html';

let requires = [NewGuidServiceName, DefectTypeServiceName, LoaderServiceName];

interface HEYEDataPointsScope extends ConfigScope {
  types: DefectType[];
  channels: EquipmentDataPoint[];
}

export default angular.module('aps.controller.heyeDataPoints', requires)
  .directive('apsHeyeDataPoints', heyeDataPoints)
  .name;

function heyeDataPoints(
  newGuidService: NewGuidService,
  defectTypeService: DefectTypeService,
  loaderService: LoaderService,
  $q: angular.IQService
): angular.IDirective {
  return {
    restrict: 'E',
    template: template,
    link: (scope: HEYEDataPointsScope) => {
      let promises = [defectTypeService.getDefectTypesAndClassificationsNoExclusion().then(results => {
        scope.types = _.sortBy(results.types, (x: DefectType) => x.name);
      })];

      let createDataPoint = (active: boolean, type: apsEnums.DataPointType, channel?: number): EquipmentDataPoint => {
        return {
          type: type,
          config: null,
          jsonConfig: {Channel: channel, Active: active},
          configType: apsEnums.DataPointConfigType.HEYECounter,
          id: null,
          name: '',
          plantLocationId: null
        };
      };

      let setPlantLocationId = () => scope.vm.dataPoints.forEach(dp =>
        dp.plantLocationId = scope.vm.location ? scope.vm.location.location.id : null);

      if (scope.vm.dataPoints.length === 0) {
        scope.vm.dataPoints.push(createDataPoint(true, apsEnums.DataPointType.Inspect));
        scope.vm.dataPoints.push(createDataPoint(true, apsEnums.DataPointType.Reject));
        for (let i = 1; i <= 32; i++) {
          scope.vm.dataPoints.push(createDataPoint(false, apsEnums.DataPointType.Reject, i));
        }

        scope.vm.dataPoints.push(createDataPoint(false, apsEnums.DataPointType.Reject, 33));// add channel 33 for mnr
        scope.vm.dataPoints.push(createDataPoint(false, apsEnums.DataPointType.Reject, 34));// add channel 34 for system reject

        promises.push(newGuidService.getNewGuids('dataPoint', scope.vm.dataPoints.length)
          .then(ids => scope.vm.dataPoints.forEach((dp, i) => dp.id = ids[i])));
        setPlantLocationId();
      }

      scope.$watch('vm.location', setPlantLocationId);

      scope.channels = scope.vm.dataPoints.filter(x => x.jsonConfig.Channel > 0);

      loaderService.loadingPromise($q.all(promises));

      let setNames = () => {
        let heyeName = (scope.vm.instance.name || 'HEYE');
        scope.vm.dataPoints.forEach(dp => {
          if (dp.jsonConfig.Channel) {
            if(dp.jsonConfig.Channel <= 32){
              dp.name = heyeName + ' CH' + ('00' + dp.jsonConfig.Channel).slice(-2);
            }
            else{
              dp.name = heyeName + ' CH' + dp.jsonConfig.Channel;
            }

            console.log(dp.jsonConfig.Channel);
            console.log(dp.name);

          } else if (dp.type === apsEnums.DataPointType.Inspect) {
            dp.name = heyeName + ' Inspect';
          } else {
            dp.name = heyeName + ' Reject';
          }
        });
      };
      setNames();
      scope.$watch('vm.instance.name', setNames);
    }
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/equipment/heyeDataPoints.directive.ts